

<template>
    <div>
        <input :id="'input' + randomId" class="form-control" type="text" :placeholder="schema.placeholder">
        <b-typeahead :open-on-empty="true" v-model="value" limit="10" :target="'#input' + randomId" :data="schema.values" item-key="name">
            <template slot="item" slot-scope="props">
                <li v-for="(item, index) in props.items" :key="index" :class="{'bg-gray-200': props.activeIndex===index}">
                    <a role="button" class="block cursor-pointer px-3 py-1.5 text-sm" @click="props.select(item)">
                        <span v-html="props.highlight(item)"></span>
                    </a>
                </li>
            </template>
        </b-typeahead>
        <span class="green-text" v-if="typeof value === 'string' && value !== ''">{{schema.newItem}}</span>
    </div>
</template>

<script>
import { abstractField } from 'vue-form-generator'

export default {
    mixins: [ abstractField ],
    data () {
        return {
            randomId: Math.floor(Math.random() * 1000)
        }
    }
}
</script>
<style scoped>
    .green-text {
        color: #05b408
    }
    .dropdown-menu .active a {
        background-color: #8c8c8c;
    }
</style>
